<template>
  <div
    class="skeleton-loading bg-white flex flex-col card-rounded card-p clamp-gap-7-12 clamp-h-80-134 col-span-12 tp:col-span-6 tl:col-span-4 overflow-hidden"
  >
    <div class="flex flex-col clamp-gap-5-8">
      <span
        class="skeleton-loading-date clamp-max-w-50-60 tp:clamp-max-w-40-45 w-full clamp-h-4-5 inline-block bg-skeleton"
      ></span>
      <div class="flex flex-col clamp-gap-2-4">
        <span
          v-for="headline in 3"
          class="skeleton-loading-headline clamp-max-w-60-250 tp:clamp-max-w-50-90 w-full clamp-h-6-9 inline-block bg-skeleton"
        ></span>
      </div>
    </div>
    <div class="flex flex-col clamp-gap-2-5 relative overflow-hidden">
      <div
        v-for="line in 4"
        class="skeleton-loading-content w-full tp:clamp-max-w-70-110 w-full clamp-h-5-6 inline-block bg-skeleton"
      ></div>
      <div
        class="fade-effect absolute bottom-0 left-0 w-full clamp-h-10-40 pointer-events-none"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.skeleton-loading-date,
.skeleton-loading-headline,
.skeleton-loading-content {
  animation: shimmer 2s infinite linear;
  background: linear-gradient(to right, #ddd 8%, #eee 18%, #ddd 33%);
  background-size: 1000px 100%;
  @apply bg-skeleton;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.fade-effect {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
}
</style>
